module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("Password requirements:\n<ul>\n  <li class='" + ($e($c(this.hasMoreThan8Characters))) + "'>\n    8 or more characters\n  </li>\n  <li class='" + ($e($c(this.hasOneDigitAndOneLetter))) + "'>\n    At least one number and one letter\n  </li>\n  <li class='" + ($e($c(this.hasMixOfUpperAndLower))) + "'>\n    A mix of uppercase and lowercase letters\n  </li>\n  <li class='" + ($e($c(this.doesNotContainUsername))) + "'>");
      $o.push("    " + $e($c("" + this.usernameCheckInfo)));
      $o.push("  </li>\n  <li class='" + ($e($c(this.doesNotHaveIdenticalCharacters))) + "'>\n    Does not contain 3 or more identical characters Ex. aaa or 111\n  </li>\n  <li class='" + ($e($c(this.doesNotHaveConsecutiveCharacters))) + "'>\n    Does not contain 3 or more consecutive characters Ex. abc or 123\n  </li>\n  <li class='" + ($e($c(this.hasOneSpecialCaracter))) + "'>\n    Must contain one special characters such as");
      $o.push("    " + $e($c(this.specialCharacters.join(" "))));
      $o.push("  </li>\n</ul>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/shared/templates/password_requirements.js.hamlc
// module id = 1651
// module chunks = 10